import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TeAiService} from "../../../service/api/te-ai.service";
import {TeAiVariableSuggestionDto} from "../../../model/dto/api/te-ai-variable-suggestion.dto";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";

@Component({
    selector: 'te-ai-variable-suggestion-panel',
    templateUrl: './te-ai-variable-suggestion-panel.component.html',
    standalone: false
})
export class TeAiVariableSuggestionPanelComponent implements OnInit {

    @Input() templateId: number;
    @Input() blueprintId: number;
    @Input() content: string;
    @Output() onApplied = new EventEmitter<void>();

    suggestions: TeAiVariableSuggestionDto[] = [];
    loading: boolean = false;

    constructor(
        private aiService: TeAiService,
        private messageService: MvsMessageService
    ) {}

    ngOnInit() {
        if (this.templateId || this.blueprintId || this.content) {
            this.loadSuggestions();
        }
    }

    loadSuggestions() {
        this.loading = true;
        this.aiService.suggestVariables({
            templateId: this.templateId,
            blueprintId: this.blueprintId,
            content: this.content
        }).subscribe({
            next: (result) => {
                this.suggestions = result.map(s => ({...s, selected: s.confidence >= 0.7}));
                this.loading = false;
            },
            error: () => {
                this.messageService.showErrorMessage('AI', 'Fehler bei der Variablenvorschlag.');
                this.loading = false;
            }
        });
    }

    applySelected() {
        const selected = this.suggestions.filter(s => s.selected);
        if (!selected.length) return;

        this.loading = true;
        this.aiService.applyVariables({
            templateId: this.templateId,
            blueprintId: this.blueprintId,
            suggestions: selected
        }).subscribe({
            next: () => {
                this.messageService.showSuccessMessage('AI', `${selected.length} Variablen angewendet.`);
                this.loading = false;
                this.onApplied.emit();
            },
            error: () => {
                this.messageService.showErrorMessage('AI', 'Fehler beim Anwenden.');
                this.loading = false;
            }
        });
    }

    toggleAll(checked: boolean) {
        this.suggestions.forEach(s => s.selected = checked);
    }

    hasSelected(): boolean {
        return this.suggestions.some(s => s.selected);
    }

    getConfidenceSeverity(confidence: number): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' {
        if (confidence >= 0.8) return 'success';
        if (confidence >= 0.5) return 'warn';
        return 'danger';
    }

    getConfidenceLabel(confidence: number): string {
        if (confidence >= 0.8) return 'Hoch';
        if (confidence >= 0.5) return 'Mittel';
        return 'Niedrig';
    }

    getSourceIcon(source: string): string {
        switch (source) {
            case 'pattern': return 'fa-regular fa-code';
            case 'schema': return 'fa-regular fa-database';
            case 'llm': return 'fa-regular fa-brain';
            default: return 'fa-regular fa-question';
        }
    }
}
